export enum RoutePathType {
  NotFound = '*',
  Activation = '/activation',
  Admin = '/admin',
  AdminConsole = '/admin/console',
  AdminConsoleClient = '/admin/console/:clientId',
  AdminConsoleClientAuditLogs = '/admin/console/:clientId/audit-logs',
  AdminConsoleClientCopyWorkflow = '/admin/console/:clientId/copy-workflow',
  AdminConsoleClientDataFields = '/admin/console/:clientId/data-fields',
  AdminConsoleClientDepartments = '/admin/console/:clientId/departments',
  AdminConsoleClientDepartmentsDepartment = '/admin/console/:clientId/department/:departmentId',
  AdminConsoleClientEmailIntake = '/admin/console/:clientId/email-intake',
  AdminConsoleClientIntegrations = '/admin/console/:clientId/integrations',
  AdminConsoleClientProcurement = '/admin/console/:clientId/procurement',
  AdminConsoleClientManagePartyLists = '/admin/console/:clientId/manage-party-lists',
  AdminConsoleClientMoreSettings = '/admin/console/:clientId/more-settings',
  AdminConsoleClientProcessDocuments = '/admin/console/:clientId/process-documents',
  AdminConsoleClientRestorationHub = '/admin/console/:clientId/restoration-hub',
  AdminConsoleClientSamlConfiguration = '/admin/console/:clientId/saml-configuration',
  AdminConsoleClientSamlConfigurationFormConfig = '/admin/console/:clientId/saml-configuration/form/:configId',
  AdminConsoleClientUsers = '/admin/console/:clientId/users',
  AdminConsoleClientDocumentManagement = '/admin/console/:clientId/document-management',
  AdminConsoleClientCRM = '/admin/console/:clientId/crm',
  AdminConsoleClientApiManagement = '/admin/console/:clientId/api-management',
  AdminConsoleClientWebhooks = '/admin/console/:clientId/webhooks',
  AdminClientCredits = '/admin/:clientId/credits',
  AdminRoles = '/admin/:clientId/roles/',
  AdminUsers = '/admin/:clientId/users',
  AutomationHub = '/automation',
  AutomationHubFields = '/automation/fields',
  AutomationHubFieldModel = '/automation/fields/:modelId',
  AutomationHubFieldModelDebug = '/automation/fields/:modelId/debug',
  AutomationHubDetail = '/automation/detail',
  RoutingTable = '/automation/routing-table',
  Alerts = '/alerts',
  Analyzer = '/analyzer',
  AnalyzerResults = '/analyzer/results',
  AnalyzerSavedSearches = '/analyzer/saved-searches',
  AgentForgeInvoke = '/agentforge-invoke',
  Onboarding = '/onboarding',
  ChangePassword = '/change-password',
  ClauseLibrary = '/clause-library',
  ClauseLibraryInstance = ':clauseId',
  Dashboards = '/dashboards/',
  Dashboard = '/dashboards/:dashboardId',
  Document = '/document/:documentId',
  DocumentRedirect = '/document',
  DocumentGroups = '/document-groups',
  DocumentGroupsNew = '/document/groups',
  DocumentGroupGroup = '/document-group/:groupId',
  DocumentsGroupDetail = '/documents/groups/:groupId',
  Documents = '/documents',
  DocumentsFolder = '/documents/:folderId',
  DownloadEmailAttachmentPage = '/download-email-attachment',
  DownloadExportReportPage = '/download-export-report',
  ExpiredToken = '/expired-token',
  ExternalDocumentViewer = '/external-document-viewer',
  FoldersPermissionCheck = '/folders-permission-check',
  ForgotPassword = '/forgot-password',
  Guidelines = '/guidelines/:guidelineId?',
  Home = '/',
  Login = '/login',
  LoginEmbed = '/login/embed',
  LoginEmbedSuccess = '/login/embed/success',
  ManagedEntities = '/entities/parties',
  MyDeletedDocuments = '/my-deleted-items',
  Playbooks = '/playbooks/:playbookId?',
  SavedDashboards = '/saved-dashboards',
  SavedSearches = '/saved-searches',
  Search = '/search',
  SavedSearch = '/search/:searchId',
  Settings = '/settings',
  SuperAdminUsers = '/super-admin/users',
  TicketEmailActionError = '/invalid-email-action-token/',
  TicketEmailApproveConfirmation = '/email-action-approve-succeeds/',
  TicketEmailApproveComment = '/tickets/:ticket_id/judgment-results/:judgment_result_id/:jwt/approve/',
  TicketEmailRejectComment = '/tickets/:ticket_id/judgment-results/:judgment_result_id/:jwt/reject/',
  TicketEmailRejectConfirmation = '/email-action-reject-succeeds/',
  Unauthorized = '/unauthorized',
  Upload = '/upload',
  WorkflowBuilder = '/workflow/builder',
  WorkflowBuilderWorkflow = '/workflow/builder/:workflowId',
  WorkflowIntakeFormLink = '/workflow/:workflowId/intake-form/link',
  IntegrateWorkflowIntakeFormLink = '/integrate-workflow/:workflowId/intake-form/link',
  IntegrateWorkflowAmendIntakeForm = '/integrate-workflow/amend/:contractRecordUniqueId/intake-form',
  WorkflowTickets = '/workflow/tickets',
  WorkflowGroups = '/workflow/groups',
  WorkflowGroupDetail = '/workflow/groups/:groupId',
  WorkflowTicketsNew = '/workflow/tickets/new',
  WorkflowTicketsTicket = '/workflow/tickets/:ticketId',
  WorkflowTicketsReroute = '/contract',
  WorkflowTicketsTicketReviewerVersionNumber = '/workflow/tickets/:ticketId/reviewer/:versionNumber',
  WorkflowCLMEvolutionTickets = '/workflows-clm-evolution/tickets',
  WorkflowCLMEvolutionTicketsDetail = '/workflows-clm-evolution/tickets/:ticketId',
  WorkflowCLMEvolutionWorkflows = '/workflows-clm-evolution/workflows',
  WorkflowCLMEvolutionWorkflowsDetail = '/workflows-clm-evolution/workflows/:workflowId',
  WordOnlineFile = '/word-online/:fileId',
  WordOnlineError = '/word-online-invalid-subscription',
  XRayLibrary = '/x-ray/library',
  XRayLibraryAdmin = '/x-ray/library/admin',
}
